import React from 'react';

// Components
import AppInitializer from './AppInitializer';

const withAppInitilizationChecks = (WrappedComponent) => {
  return () => (
    <AppInitializer>
      <WrappedComponent />
    </AppInitializer>
  );
}

export default withAppInitilizationChecks;



// WEBPACK FOOTER //
// ./src/HOC/withAppInitilizationChecks/index.js